import { render, staticRenderFns } from "./mod13.vue?vue&type=template&id=e48592f8&scoped=true&"
import script from "./mod13.vue?vue&type=script&lang=js&"
export * from "./mod13.vue?vue&type=script&lang=js&"
import style0 from "./mod13.vue?vue&type=style&index=0&id=e48592f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e48592f8",
  null
  
)

export default component.exports